export const DELAY_TIME = 300;
